import { writable } from 'svelte/store';
import * as util from "../js/util.js";

function createMyStore() {
    const { subscribe, set, update, get } = writable(new Array());

    return {
        subscribe,
        getLanguageTexts: async () => {
            var url = 'api/Lang/GetAllLanguageTexts'
            const json = await util.fetchJson(url);
            update(n => json)
        },
        getLanguageTextsFiltered: async () => {
            var url = 'api/Lang/GetAllLanguageTexts'
            const json = await util.fetchJson(url);
            update(n => json)

            return json;
        },
        import: async (thefile) => {
            let formData = new FormData();
            formData.append("thefile", thefile);
            var result = await fetch("/api/Lang/import", { method: "POST", body: formData });
            return await result.json()
        },
        importExcel: async (thefile) => {
            let formData = new FormData();
            formData.append("thefile", thefile);
            var result = await fetch("/api/Lang/importexcel", { method: "POST", body: formData });
            return await result.json()
        },
        saveSingle: async (lang) => {
            var ret = await util.fetchJsonWithMethod('PUT', 'api/Lang/savesingle', lang);

            return ret;
        },
        getSingle: async (langKey) => {
            var ret = await util.fetchJson('api/Lang/getsingle?langKey=' + langKey);

            return ret;
        },
        saveMultiple: async (theLanguageText, filter) => {
            await util.fetchJsonWithMethod('PUT', 'api/Lang/savemultiple', theLanguageText);

            languageTextsStore.getLanguageTextsFiltered(filter);
        },
        downloadExcel: async (lang) => {
            util.downloadFile('api/lang/downloadexcel?lang=' + lang, 'Fairprice-translations-' + lang + '.xlsx')
        },
        getLangs: async () => {
            return await util.fetchJson('api/lang/getlangs')
        },
        reloadOnSite: async () => {
            var url = await util.fetchJson('api/lang/getwebsiteurl')
            window.open(url.url + '/api/lang/reloadlangs')
        },
        deleteLangItem: async (langKey) => {
            await util.fetchJsonWithMethod('POST', 'api/Lang/deleteLangItem', { langKey: langKey });
            languageTextsStore.getLanguageTexts();
        },
        reset: () => set(new Array())
    };
}
export const languageTextsStore = createMyStore();

